import { Icon } from "@chakra-ui/react"
import { FaCarSide, FaTruckPickup, FaVanShuttle } from "react-icons/fa6"
import type { IconType } from "react-icons"

/**
 * Vehicle icons for the Burnaston "Capacity to Fill" card — one per entry in VEHICLE_TYPES.
 *
 * Decorative: the vehicle name is rendered as text beside the icon, so these are aria-hidden.
 */
const ICONS: Record<string, IconType> = {
  Hilux: FaTruckPickup,
  Mirai: FaCarSide,
  Caetano: FaVanShuttle,
}

interface VehicleIconProps {
  /** Matches `VehicleFill.vehicle` / `VehicleType.name`. */
  vehicle: string
  /** Sized in em so the icon tracks the type rather than a fixed pixel count. */
  size?: string
  color?: string
}

/**
 * Renders the icon for `vehicle`, or nothing if that name has no icon — adding a vehicle to
 * VEHICLE_TYPES must not break the card before its icon is chosen.
 */
// 3.5em ≈ a 56px box, so the glyph stands about as tall as the subtext + value lines it sits beside.
// Much past this and it crowds the card's 16px padding and competes with the figure value.
function VehicleIcon({ vehicle, size = "3.5em", color = "#8A8A8A" }: VehicleIconProps) {
  const icon = ICONS[vehicle]
  if (!icon) return null
  return <Icon as={icon} boxSize={size} color={color} flexShrink={0} aria-hidden />
}

export default VehicleIcon
